<template>
    <BaseDialog
        :showDialog="dialog.show"
        maxDialogWidth="640"
        maxCardHeight="640"
        headline="lang_GENERAL_DELETION_DIALOG_TITLE_DELETE_ENTRY"
        :close="close"
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid>
                <v-row v-if="dialog.loading">
                    <v-col class="text-center"><v-progress-circular indeterminate color="dialogProgressbar" /></v-col>
                </v-row>
                <template v-else>
                    <v-row v-if="deletable.length">
                        <v-col cols="12" :alvqa="alvqa + '-text-deletable'">
                            {{ $tc('lang_PUBLISHING_USAGE_CAPTION_DELETE_DIALOG_DELETABLE', deletable.length, { count: deletable.length }) }}
                            <ul class="mt-1">
                                <li v-for="dataset in deletable" :key="dataset.id">
                                    {{ dataset.description || dataset.fileName }}
                                    <span v-if="dataset.deletesComparisons && dataset.deletesComparisons.length" class="subtitleGray--text">
                                        — {{ $t('lang_PUBLISHING_USAGE_CAPTION_DELETE_DIALOG_WITH_COMPARISON') }}
                                    </span>
                                </li>
                            </ul>
                        </v-col>
                    </v-row>
                    <v-row v-if="blocked.length">
                        <v-col cols="12">
                            <v-alert color="standardBrownIcon" icon="warning_amber" dense border="left" colored-border class="mb-0" :alvqa="alvqa + '-blocked'">
                                <div class="mb-1">{{ $t('lang_PUBLISHING_USAGE_CAPTION_DELETE_DIALOG_BLOCKED') }}</div>
                                <div v-for="dataset in blocked" :key="dataset.id" class="mb-1">
                                    <strong>{{ dataset.description || dataset.fileName }}</strong>
                                    <ul>
                                        <li v-for="(blocker, i) in dataset.deleteBlockers" :key="i">{{ blocker.message }}</li>
                                    </ul>
                                </div>
                            </v-alert>
                        </v-col>
                    </v-row>
                </template>
            </v-container>
        </template>
        <template v-slot:dialogActions>
            <v-spacer />
            <BaseButton label="lang_GENERAL_BUTTON_CANCEL" color="buttonCancel" class="mr-2" :alvqa="alvqa + '-button-cancel'" @click="close" />
            <BaseButton
                v-if="deletable.length"
                label="lang_GENERIC_CAPTION_DELETE"
                color="error"
                :loading="dialog.deleting"
                :alvqa="alvqa + '-button-delete'"
                @click="$store.dispatch('deleteUsageDatasets')"
            />
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'

/** Delete explains itself: what will go (with the comparison a schedule takes along) and what cannot, and why. */
export default {
    name: 'UsageDeleteDialog',
    components: { BaseDialog, BaseButton },
    data() {
        return { alvqa: 'publishing-usage-delete-dialog' }
    },
    computed: {
        dialog() { return this.$store.getters.getUsageDeleteDialog },
        deletable() { return (this.dialog.datasets || []).filter(d => d.deletable) },
        blocked() { return (this.dialog.datasets || []).filter(d => !d.deletable) }
    },
    methods: {
        close() {
            this.$store.commit('setUsageDeleteDialog', { show: false, datasets: [], deleting: false })
            this.$store.commit('setSelectedUsageAction', [])
        }
    }
}
</script>
